import { Page } from "./page";

export class Review extends Page
{
    public who : string

    public source : string
}
